<div #modal class="show" id="confirmBookingModal" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="table-view">
    <div class="table-cell-view">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
                    <div style="    border-bottom: 1px solid rgba(100,100,100,0.15);
                        border-top: 1px solid rgba(100,100,100,0.15);">
            <div class="modal-header">
              <h5 class="modal-title" id="myModalLabel">
                <span>
                  <img class="footerimage" [src]="this.searchservice.footerLogo">
                </span>
              </h5>

              @if (!isAmnetRelease() && !transactionMode) {
                <button type="button" class="close"
                  (click)="gotToHome()">
                  <i class="material-icons">close</i>
                </button>
              }
            </div>
            <div class="modal-body">
              @if (!showHotelLink && responseType === 'ERROR_AVAILABILITY') {
                <div
                  class="modal-icon-container">
                  <span class="modal-icon" style="border:3px solid red;">
                    <i class="material-icons" style="color:red;">error</i>
                  </span>
                </div>
              }
              <!-- <div *ngIf="!multibooking && !(!showHotelLink && responseType === 'ERROR_AVAILABILITY') && this.flightBooking"
              class="modal-icon-container">
              <img src="assets/images/flgihtmsg.png" alt="logo" />
            </div>
            <div *ngIf="!multibooking && !(!showHotelLink && responseType === 'ERROR_AVAILABILITY') && !this.flightBooking"
              class="modal-icon-container">
              <span class="modal-icon">
                <i class="material-icons">check</i>
              </span>
            </div>
            <div *ngIf="multibooking"
              class="modal-icon-container">
              <span class="modal-icon">
                <i class="material-icons">check</i>
              </span>
            </div> -->
            @if (responseType !== 'ERROR_AVAILABILITY') {
              <h3>{{'successModel.BookingRequestReceived' | translate}}</h3>
            }
            @if (!transactionMode) {
              <div class="modal-content-heading">
                @if (multibooking && (responseType === 'ERROR_BOOKING_PENDING' || responseType === 'ERROR_TRIP_BOOKING_PENDING'
                  || responseType === 'ERROR_API' || responseType === 'ERROR_INTERNAL' ) ) {
                  <h3>
                    {{'successModel.WeveReceivedYourBookingRequestAndAreWorkingOnConfirmingIt' | translate}}<br><br>
                    {{'successModel.YoullGetAnEmailWithYourItineraryAndReceiptWithIn' | translate}}<br>
                  </h3>
                }
                @if (!multibooking && !showHotelLink && responseType === 'ERROR_AVAILABILITY' && !this.flightBooking) {
                  <h3
                    >
                  {{getHotelBookingErrorMessage(responseType)}}</h3>
                }
                @if (!multibooking && !showHotelLink && (responseType === 'ERROR_BOOKING_PENDING' || responseType === 'ERROR_TRIP_BOOKING_PENDING') && !this.flightBooking) {
                  <h3
                    >
                  {{getHotelBookingErrorMessage(responseType)}}</h3>
                }
                @if (!multibooking &&  !showHotelLink && responseType === 'ERROR_API' && !this.flightBooking) {
                  <h3>
                  {{getHotelBookingErrorMessage(responseType)}}</h3>
                }
                @if (!multibooking && showHotelLink && (responseType !== 'ERROR_AVAILABILITY' &&  responseType !== 'ERROR_BOOKING_PENDING')) {
                  <h3
                    >
                    {{'successModel.WeveReceivedYourBookingRequestAndAreWorkingOnConfirmingIt' | translate}}<br>
                    {{'successModel.YoullGetAnEmailWithYourItineraryAndReceiptWithIn' | translate}}
                  </h3>
                }
                @if (this.searchservice.trainFilter.length  ===0 && (!multibooking && !showHotelLink && (responseType !== 'ERROR_API' || (responseType !== 'ERROR_AVAILABILITY' ||  responseType !== 'ERROR_BOOKING_PENDING'))) && this.flightBooking) {
                  <p>
                    {{'successModel.WeveReceivedYourBookingRequestAndAreWorkingOnConfirmingIt' | translate}}<br><br>
                    {{'successModel.YoullGetAnEmailWithYourItineraryAndReceiptWithIn' | translate}}
                  </p>
                }
                @if (this.searchservice.trainFilter.length  >0 && (!multibooking && !showHotelLink && (responseType !== 'ERROR_API' || (responseType !== 'ERROR_AVAILABILITY' ||  responseType !== 'ERROR_BOOKING_PENDING'))) && this.flightBooking) {
                  <h3
                    >
                    {{'result.Wehavereceivedyourtrainbookingrequest.Pleaseallowus20minutestoprocessandconfirmthetrain.Ifyouhaveanyquestions,pleasecontactcustomersupport.' | translate}}
                  </h3>
                }
                @if (!multibooking && (!showHotelLink && responseType !== 'ERROR_API') && (responseType !== 'ERROR_AVAILABILITY' &&  responseType !== 'ERROR_BOOKING_PENDING')) {
                  <h3
                    >
                    {{'successModel.ThankyouforcompletingyourpassengerprofileYourbookingrequestisonitsway'
                  | translate}}</h3>
                }
              </div>
            }
            @if (transactionMode) {
              <div class="modal-content-heading">
                <h3> {{'successModel.Thankyouforcompletingyourpassengerprofile,yourtransactionrequestisonitsway.' | translate}}</h3>
              </div>
            }
            @if (transactionMode) {
              <div class="modal-content-heading">
                <p> {{'successModel.Pleasewait,RedirectingyoubacktoTripDetailsassoonasTransactionisgenerated.' | translate}}</p>
              </div>
            }
            @if (!transactionMode) {
              <div class="modal-content-heading">
                <p>{{NeedHelpTextUsAtMessage()}}</p>
              </div>
            }
            <!-- <div *ngIf="!multibooking && responseType != 'ERROR_TRIP_BOOKING_PENDING' && this.bookingResponse1 && this.bookingResponse1.bookedHotels && this.bookingResponse1.bookedHotels.length > 0 && this.bookingResponse1.bookedHotels[0].reservationCode"
            class="modal-content-button">
            <button class="text-button link-primary" style="width: auto;cursor:pointer"
            (click)=" goToItinerary()"> {{'successModel.showmeitinerary' | translate}}</button>
          </div>
          <div *ngIf="multibooking && responseType === 'ERROR_TRIP_BOOKING_PENDING'"
            class="modal-content-button">
            <button class="text-button link-primary" style="width: auto;cursor:pointer"
            (click)=" goToItinerary()"> {{'successModel.showmeitinerary' | translate}}</button>
          </div> -->
          @if (!showMultipleItenerariesLink() && this.bookingResponse1) {
            <div
              class="modal-content-button">
              <button class="text-button link-primary" style="width: auto;cursor:pointer"
              (click)=" goToItinerary()"> {{'successModel.showmeitinerary' | translate}}</button>
            </div>
          }
          @if (showMultipleItenerariesLink() && this.bookingResponse1) {
            <div
              class="modal-content-button" style="display: flex;">
              <div class="leftside">
                <span class="text-button" style="width: auto;"
                > {{'successModel.showmeitinerary' | translate}}</span>
              </div>
              <div class="rightside" style="display: block;">
                @for (item of this.bookingResponse1.multiBookingResponse; track item) {
                  <div >
                    <a [routerLink]="['/bookingHistory']"
                                      [queryParams]="{type: 'detail',bookingType:'upcoming',ticketid:item.ticketId,
                                      tripid:item.tripId,transactionid:item.transactionId,tripSessionId:item.tripSessionId}" routerLinkActive="active"(click)="cancelModel()">{{item.travellerDetails.travellers[0].firstName}} {{item.travellerDetails.travellers[0].lastName}}</a>
                  </div>
                }
              </div>
            </div>
          }
          @if (this.bookingResponse1 && this.bookingResponse1.bookedHotels && this.bookingResponse1.bookedHotels.length > 0 && !this.bookingResponse1.bookedHotels[0].reservationCode) {
            <div
              class="modal-content-button">
              <button class="text-button link-primary" style="width: auto;cursor:pointer"
              (click)="gotToHome()"> {{'successModel.close' | translate}}</button>
            </div>
          }
          @if ((!this.bookingResponse1) && (!transactionMode && !showHotelLink)) {
            <div
              class="modal-content-button">
              <!-- <button class="text-button link-primary" style="width: auto;cursor:pointer"
            (click)="gotToHome()"> {{'successModel.close' | translate}}</button> -->
          </div>
        }
        @if (!showHotelLink && responseType === 'ERROR_AVAILABILITY' ) {
          <div>
            <button class="text-button link-primary" style="width: auto;cursor:pointer"
            (click)="gotoSearchHotelAgain()">{{'successModel.searchAgain' | translate}}</button>
          </div>
        }

      </div>
    </div>
  </div>
</div>
</div>
</div>
</div>